<template>
  <v-app>
    <!-- App Bar -->
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <img src="/aushadh-logo.png" alt="Aushadh Health" class="logo mr-3">
        Admin Portal
      </v-toolbar-title>
      <v-spacer></v-spacer>
      
      <!-- User Menu -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>Admin User</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click="handleLogout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Navigation Drawer -->
    <v-navigation-drawer v-model="drawer" app>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item
            v-for="item in navigationItems"
            :key="item.title"
            :to="item.to"
            link
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        
        <v-divider class="my-2"></v-divider>
        
        <v-list-item @click="handleLogout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Main Content -->
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { config as appConfig } from '@/config'

const router = useRouter()
const drawer = ref(true)

const navigationItems = [
  { title: 'Dashboard', icon: 'mdi-view-dashboard', to: '/dashboard' },
  { title: 'Email Inbox', icon: 'mdi-email', to: '/email-inbox' },
  { title: 'Service Health', icon: 'mdi-heart-pulse', to: '/service-health' },
  { title: 'Beta Users', icon: 'mdi-account-group', to: '/beta-users' },
  { title: 'Feature Flags', icon: 'mdi-toggle-switch', to: '/feature-flags' },
  { title: 'User Feedback', icon: 'mdi-message-text', to: '/user-feedback' },
  { title: 'News Management', icon: 'mdi-newspaper', to: '/news-management' },
  { title: 'AI Prompts', icon: 'mdi-robot', to: '/ai-prompts' },
  { title: 'Audit Logs', icon: 'mdi-file-document-outline', to: '/audit-logs' }
]

const handleLogout = () => {
  // Clear all auth-related items
  localStorage.removeItem(appConfig.auth.tokenKey)
  localStorage.removeItem('adminUser')
  
  // Clear any other potential auth tokens
  const keysToRemove = ['adminToken', 'token', 'jwtToken', 'access_token']
  keysToRemove.forEach(key => localStorage.removeItem(key))
  
  router.push('/login')
}
</script>

<style scoped>
.logo {
  height: 30px;
  vertical-align: middle;
}
</style>